<template>
  <div class="jps-curation-image-annotaion">
    <ClientOnly>
      <UiIiifViewer
        v-if="viewerInfo"
        mode="show-rect"
        :no-rotation="true"
        :no-iiif-logo="true"
        :image="viewerInfo"
        :rects="rects"
        :annots="annots"
        @select-rect="selectRect"
      >
        <template #info="">
          <UiRightsTag
            :rights="def.image.contentsRightsType"
            :rights-description="def.image.contentsRights"
          />
          <a
            class="jps-curation-modal-rights-info source-link"
            v-if="def.image.source"
            :href="def.image.sourceUrl"
          >
            {{ ls(def.image.source) }}
            <BaseIcon name="mdi/open-in-new" />
          </a>
        </template>
      </UiIiifViewer>
    </ClientOnly>
    <div class="jps-annotation" v-if="currentAnnot && !isAnnotEmpty">
      <div class="jps-annotation-title">{{ ls(currentAnnot.title) }}</div>
      <div class="jps-annotation-description">
        {{ ls(currentAnnot.description) }}
      </div>
      <CurationPartsRenderer :curation="curation" :parts="currentAnnot.parts" />
    </div>
  </div>
</template>

<script lang="ts" setup>
const { ls } = useI18n()
const { compImageSelection, toViewerInfo } = useImageSelection()

interface Props {
  def: PartImageAnnotation
  curation: Curation
}
const props = withDefaults(defineProps<Props>(), {})

const currentAnnot: Ref<PartAreaAnnotation> = ref(null)
onBeforeMount(() => {
  currentAnnot.value = props.def.initial
})

const selectRect = (i: number) => {
  if (currentAnnot.value === props.def.parts[i] || i < 0) {
    currentAnnot.value = props.def.initial
  } else {
    currentAnnot.value = props.def.parts[i]
  }
}

const isAnnotEmpty = computed(() => {
  return (
    isEmpty(currentAnnot.value.title) &&
    isEmpty(currentAnnot.value.description) &&
    isEmpty(currentAnnot.value.parts)
  )
})

const viewerInfo = computed(() => {
  return toViewerInfo(compImageSelection(props.def.image))
})

const rects = computed(() => {
  if (props.def.parts) {
    return props.def.parts.map(a => a.rect)
  }
  return []
})

const annots = computed((): LangString[] => {
  if (props.def.parts) {
    return props.def.parts.map(a => a.title)
  }
  return []
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-curation-image-annotaion {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  @include is-mobile {
    margin: 0.5rem 1rem;
  }

  .iiif-viewer {
    margin-left: 0;
    margin-right: 0;
    max-width: 100%;
    background-color: $jps-gray-100;
  }
  .jps-annotation {
    background: $jps-gray-100;
    padding-top: 1rem;
    .jps-annotation-title {
      font-size: 1.5rem;
      @include base-content-width();
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    }
    .jps-annotation-description {
      @include base-content-width();
      padding-bottom: 1.5rem;
      @include is-mobile() {
        font-size: 0.8125rem;
      }
    }
  }

  .source-link {
    display: flex;
    align-items: center;
  }
}
</style>
